// extracted by mini-css-extract-plugin
export default {"socialContainer":"styles_socialContainer__rwXd7","socialIcon":"styles_socialIcon__Gl3a3"};